import { render, staticRenderFns } from "./ArrowInBox.vue?vue&type=template&id=81be9f7c"
import script from "./ArrowInBox.vue?vue&type=script&lang=js"
export * from "./ArrowInBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports